<template>
  <div class="tagsview">
    <div class="tagiconl" @click.stop="scroll($event,'left')"><el-icon size="14"><arrow-left-bold /></el-icon></div>
    <div class="tagslist">
      <div :class="['tagls',isActive(p)?'tagcur':'']" v-for="(p,key) in data" :key="key" @click="OpenUrl(p.path,p.query)" @contextmenu="rightMenu($event,p)">
        {{p.title}}
        <span class="tagico" v-if="p.path!='/'" @click.stop="close_tag(p)"><el-icon size="12"><close /></el-icon></span>
      </div>
    </div>
    <div class="tagiconr" @click.stop="scroll($event,'right')"><el-icon size="14"><arrow-right-bold /></el-icon></div>
    <div class="shadeCloseTag" v-if="show_meun" @contextmenu="close_menu" @click="close_menu">
      <div class="rmenuw" :style="{'left':leftSpecs+'px'}">
        <div class="rmenulis" @click="closeTags('other')">关闭其它</div>
        <div class="rmenulis" @click="closeTags('all')">关闭所有</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TagsView',
  data(){
    return{
      data:this.$store.state.tagsview.allviews,
      show_meun:false,
      leftSpecs:200,
      selRoute:{}
    }
  },
  methods:{
    isActive(route) {
      return route.path == this.$route.path;
    },
    scroll:function (event,dire){
      if(dire=='right'){//向右
        event.currentTarget.previousSibling.scrollLeft+=300;
      }else{//向左
        event.currentTarget.nextSibling.scrollLeft-=300
      }
    },
    /**
     * 弹出右键菜单
     */
    rightMenu:function (e,route){
      event.preventDefault();
      window.event.returnValue = false;
      this.selRoute=route;
      this.show_meun=true;
      this.leftSpecs=parseInt(e.clientX)-38
    },
    /**
     * 关闭右键菜单
     */
    close_menu:function (){
      event.preventDefault();
      window.event.returnValue = false;
      this.show_meun=false;
    },
    /**
     * 关闭标签
     */
    closeTags:function (type){
      if(type=='all'){
        this.OpenUrl('/');
        this.$store.commit('close_tag',['/']);
      }else{
        this.OpenUrl(this.selRoute.path,this.selRoute.query);
        this.$store.commit('close_tag',['/',this.selRoute.path]);
      }
    }
  }
}
</script>
<style lang="less">
@import "~@/assets/css/common/tagsview";
</style>
